import { render, staticRenderFns } from "./CallInPopup.vue?vue&type=template&id=18a67515&scoped=true"
import script from "./CallInPopup.vue?vue&type=script&lang=js"
export * from "./CallInPopup.vue?vue&type=script&lang=js"
import style0 from "./CallInPopup.vue?vue&type=style&index=0&id=18a67515&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a67515",
  null
  
)

export default component.exports